<template>
  <div class="user-information" :class="{'vertical-responsive': verticalResponsive}">
    <avatar :first-name="firstName" :last-name="lastName" :other="other" />
    <div class="user-information-details">
      <strong class="user-information-details-name">{{ firstName }} {{ lastName }}</strong>
      <div class="user-information-details-email subtle">{{ email }}</div>
    </div>
  </div>
</template>

<script>
import Avatar from './avatar';

export default {
  components: {
    Avatar,
  },
  props: {
    verticalResponsive: {
      type: Boolean,
      default: false,
    },
    other: {
      type: Boolean,
      default: false,
    },
    firstName: {
      type: String,
      default: '',
    },
    lastName: {
      type: String,
      default: '',
    },
    email: {
      type: String,
      default: '',
    },
  },
};
</script>
<style lang="scss" scoped>
.user-information {
  display: flex;
}

.user-information-details-email {
  overflow: hidden;
  text-overflow: ellipsis;
}

.user-information-details {
  margin-left: 0.5rem;
}

@media screen and (min-width: 768px) and (max-width: 1080px) {
  .user-information-details {
    max-width: 200px;
  }
}

@media screen and (max-width: 400px) {
  .user-information-details-email {
    width: 210px;
  }

  .vertical-responsive {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;

    .avatar, .user-information-details-name {
      margin-bottom: 0.75rem;
    }
  }
}

</style>
